module.exports = "<button ng-class=vm.buttonClass ng-click=vm.open()><i class=\"fa fa-film\"></i> {{vm.buttonText | translate}} <i class=\"fa fa-chevron-right\"></i> </button> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-movie-button/cn-movie-button.html
 ** module id = 71
 ** module chunks = 0
 **/